export enum ProtectedAreasIbat {
  // Keep order of protected areas consistent with their severity
  'Ia' = 'Ia',
  'Ib' = 'Ib',
  'II' = 'II',
  'III' = 'III',
  'IV' = 'IV',
  'V' = 'V',
  'VI' = 'VI',
  'not_assigned' = 'Not_Assigned',
}

export enum ProtectedAreasOsm {
  'habitat_and_species_management_area' = 'Habitat_&_Species_Management_Area',
  'strictly_protected_area' = 'Strictly_Protected_Area',
  'national_park_natural_monument' = 'National_Park_/_Natural_Monument',
  'protected_landscape_and_sustainable_use_area' = 'Protected_Landscape_&_Sustainable_Use_Area',
  'water_protection_area' = 'Water_Protection_Area',
  'unclassified' = 'Unclassified',
  'minimally_protected_mpa' = 'Minimally_Protected_MPA',
  'indigenous_territory' = 'Indigenous_Territory',
  'no_take_reserve' = 'No-Take_Reserve',
  'highly_protected_mpa' = 'Highly_Protected_MPA',
  'lightly_protected_mpa' = 'Lightly_Protected_MPA',
  'internationally_recognized_area' = 'Internationally_Recognized_Area',
  'cultural_site' = 'Cultural_Site',
  'unclassified_marine_area' = 'Unclassified_Marine_Area',
}

export enum ProtectedAreasOsmRealm {
  terrestrial = 'terrestrial',
  marine = 'marine',
}

export const ProtectedAreasOsmRealmMap: Record<ProtectedAreasOsmRealm, ProtectedAreasOsm[]> = {
  // Keep order of protected areas consistent with their severity
  [ProtectedAreasOsmRealm.terrestrial]: [
    ProtectedAreasOsm.strictly_protected_area,
    ProtectedAreasOsm.national_park_natural_monument,
    ProtectedAreasOsm.habitat_and_species_management_area,
    ProtectedAreasOsm.protected_landscape_and_sustainable_use_area,
    ProtectedAreasOsm.indigenous_territory,
    ProtectedAreasOsm.water_protection_area,
    ProtectedAreasOsm.internationally_recognized_area,
    ProtectedAreasOsm.cultural_site,
    ProtectedAreasOsm.unclassified,
  ],
  [ProtectedAreasOsmRealm.marine]: [
    ProtectedAreasOsm.no_take_reserve,
    ProtectedAreasOsm.highly_protected_mpa,
    ProtectedAreasOsm.lightly_protected_mpa,
    ProtectedAreasOsm.unclassified_marine_area,
    ProtectedAreasOsm.minimally_protected_mpa,
  ],
};

export const PROTECTED_AREAS_OSM_ORDER: ProtectedAreasOsm[] = [
  // Protected areas ordered by severity
  ...ProtectedAreasOsmRealmMap[ProtectedAreasOsmRealm.terrestrial],
  ...ProtectedAreasOsmRealmMap[ProtectedAreasOsmRealm.marine],
];

export const PROTECTED_AREAS_IBAT_ORDER: ProtectedAreasIbat[] = [
  // Protected areas ordered by severity
  ...Object.values(ProtectedAreasIbat),
];

export const ProtectedAreas = {
  ...ProtectedAreasIbat,
  ...ProtectedAreasOsm,
} as const;

export const reverseProtectedAreas = Object.fromEntries(
  Object.entries(ProtectedAreas).map(([k, v]) => [v, k]),
) as Record<(typeof ProtectedAreas)[keyof typeof ProtectedAreas], keyof typeof ProtectedAreas>; // Necessary to get the enum key from the value since the BE is returning values that can't be used as object keys

export const PROTECTED_AREAS_IBAT_COLORS: Record<ProtectedAreasIbat, string> = {
  [ProtectedAreasIbat.Ia]: '#EEF100',
  [ProtectedAreasIbat.Ib]: '#FEDB8C',
  [ProtectedAreasIbat.II]: '#AB7D75',
  [ProtectedAreasIbat.III]: '#EBECCC',
  [ProtectedAreasIbat.IV]: '#99CAE2',
  [ProtectedAreasIbat.V]: '#4B7BB7',
  [ProtectedAreasIbat.VI]: '#F2A900',
  [ProtectedAreasIbat.not_assigned]: '#9E9E9E',
} as const;

export const PROTECTED_AREAS_OSM_COLORS: Record<ProtectedAreasOsm, string> = {
  [ProtectedAreasOsm.strictly_protected_area]: '#FAFF62',
  [ProtectedAreasOsm.national_park_natural_monument]: '#7CC36B',
  [ProtectedAreasOsm.habitat_and_species_management_area]: '#FEDB8C',
  [ProtectedAreasOsm.protected_landscape_and_sustainable_use_area]: '#FFC540',
  [ProtectedAreasOsm.water_protection_area]: '#2FB8B8',
  [ProtectedAreasOsm.unclassified]: '#C4C4C4',
  [ProtectedAreasOsm.minimally_protected_mpa]: '#99DEFF',
  [ProtectedAreasOsm.indigenous_territory]: '#CC6B2C',
  [ProtectedAreasOsm.no_take_reserve]: '#08519C',
  [ProtectedAreasOsm.highly_protected_mpa]: '#3182BD',
  [ProtectedAreasOsm.lightly_protected_mpa]: '#63A8FF',
  [ProtectedAreasOsm.internationally_recognized_area]: '#FF907D',
  [ProtectedAreasOsm.cultural_site]: '#B46DFF',
  [ProtectedAreasOsm.unclassified_marine_area]: '#AEC6CF',
} as const;
